import { usePostMutation } from "@/api/swr/useMutation";
import { certificateIssueSchema } from "@/schema/console/certifications/CertificateIssue";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof certificateIssueSchema, z.ZodNull>
>[3];

export const useIssueCertificate = (id: string, config?: Config) => {
  return usePostMutation(
    certificateIssueSchema,
    z.null(),
    `/console/certifications/${id}/confirm`,
    config,
  );
};
